import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { LocalStorageService } from '../services/local-storage.service';
import { E_ThemeOption } from '../enums/themes.enum';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  private storage = inject(LocalStorageService)


  private currentTheme: BehaviorSubject<E_ThemeOption> = new BehaviorSubject<E_ThemeOption>(E_ThemeOption.Light);

  constructor() {
    const localTheme = this.storage.getItem('preferredTheme');
    this.setTheme(localTheme);
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
    prefersDark.addEventListener('change', (mediaQueryListEvent) => {
      const newTheme = mediaQueryListEvent.matches ? E_ThemeOption.Dark : E_ThemeOption.Light;
      this.setTheme(newTheme);
    });
  }

  getTheme():Observable<Omit<E_ThemeOption, E_ThemeOption.System>> {
    return this.currentTheme.asObservable();
  }

  setTheme(theme: E_ThemeOption) {
    switch (theme) {
      // case 'dark':
      //   this.currentTheme.next('dark');
      //   break;
      default:
      case E_ThemeOption.Light:
        this.currentTheme.next(E_ThemeOption.Light);
        break;

        // const preferredTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
        // const preferredTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? E_ThemeOption.Dark : E_ThemeOption.Light;
        // this.currentTheme.next(preferredTheme);
        // break;
    }
    this.storage.setItem('preferredTheme', this.currentTheme.getValue());
    document.documentElement.setAttribute('data-theme', this.currentTheme.getValue());
  }

}
